// Loading skeleton matched to the EditPresetMenu layout — breadcrumb header,
// Overview heading placeholder, and footer with a Save changes button. Keep
// in sync with Components::Skeletons::PresetMenuEdit (Phlex) so SSR →
// hydration doesn't restart the shimmer animation.

import { Bar, DEFAULT_LABEL, PageShell } from '../Skeleton/primitives';

export function EditPresetMenuSkeleton({ label = DEFAULT_LABEL }: { label?: string }) {
  return (
    <PageShell label={label}>
      <SkeletonHeader />
      <div className="flex-1 overflow-y-auto py-8">
        <div className="w-full px-16 space-y-8">
          <section>
            <Bar className="h-[30px] w-32" />
          </section>
        </div>
      </div>
      <SkeletonFooter />
    </PageShell>
  );
}

function SkeletonHeader() {
  return (
    <header className="flex-shrink-0 h-23 border-b border-dinnerplate-white">
      <div className="flex h-full w-full items-center justify-between px-12">
        <Bar className="h-5 w-[160px]" />
        <Bar className="h-[45px] w-[194px] rounded-input" />
      </div>
    </header>
  );
}

function SkeletonFooter() {
  return (
    <footer className="flex-shrink-0 h-23 border-t border-dinnerplate-white">
      <div className="flex h-full w-full items-center justify-end px-16">
        <Bar className="h-[45px] w-[120px] rounded-input" />
      </div>
    </footer>
  );
}
